import { useTranslation } from 'react-i18next'

type LoaderSize = 'sm' | 'md'

const sizeMap: Record<LoaderSize, { spinner: string; text: string }> = {
  sm: {
    spinner: 'h-4 w-4 border-2',
    text: 'text-sm',
  },
  md: {
    spinner: 'h-5 w-5 border-2',
    text: 'text-base',
  },
}

export function Loader({
  label,
  size = 'md',
  centered = false,
  className = '',
}: {
  label?: string
  size?: LoaderSize
  centered?: boolean
  className?: string
}) {
  const { t } = useTranslation()
  const resolvedLabel = label ?? t('common.loading')
  const sizing = sizeMap[size]

  return (
    <div
      role="status"
      aria-live="polite"
      className={`${centered ? 'flex items-center justify-center' : 'flex items-center'} gap-2 text-[var(--stryzh-color-text-secondary)] ${sizing.text} ${className}`.trim()}
    >
      <span
        aria-hidden="true"
        className={`${sizing.spinner} inline-block animate-spin rounded-full border-[var(--stryzh-color-border-default)] border-t-[var(--stryzh-color-accent-orange)]`}
      />
      <span>{resolvedLabel}</span>
    </div>
  )
}
